// PR-B: per-visitor discount-rollout loader.
//
// Hits /api/discount once per page load, sets window.clientDiscount, and
// fires a `discount-loaded` event on `document` (matches the existing
// `currency-change` pattern in <price-display>). <price-display>
// elements with `data-rollout-eligible="true"` consult window.clientDiscount
// at render time, so this loader's only job is to populate the global +
// dispatch the event — late-upgraded elements (room-availability fragment,
// /api/search/html "load more") also read window.clientDiscount synchronously
// during their connectedCallback if the loader has already resolved.
//
// NO sessionStorage cache (round-2 audit MEDIUM): admin flips of the
// rollout percentage become visible on next page load, not next tab open.
// The endpoint sets Cache-Control: private, no-store; browser may cache
// briefly per HTTP semantics but that's transient.
//
// Race / silent denial: visitors who deep-link to /property/<slug> and
// click Reserve before this fetch resolves see un-discounted prices AND
// /api/bookings charges un-discounted — consistent. Accepted product call.
//
// Failure mode: on 5xx / network error, window.clientDiscount is set to
// {in_bucket: false, pct: 0} and the event still fires so listeners
// don't hang waiting forever.

(function () {
    function _setAndDispatch(payload) {
        window.clientDiscount = payload;
        try {
            document.dispatchEvent(new CustomEvent('discount-loaded', { detail: payload }));
        } catch (e) { /* legacy browser */ }
    }

    function _fetchAndApply() {
        fetch('/api/discount', { credentials: 'same-origin' })
            .then(function (r) {
                if (!r.ok) throw new Error('discount fetch: ' + r.status);
                return r.json();
            })
            .then(function (data) {
                _setAndDispatch({
                    in_bucket: !!(data && data.in_bucket),
                    pct: (data && typeof data.pct === 'number') ? data.pct : 0,
                });
            })
            .catch(function () {
                _setAndDispatch({ in_bucket: false, pct: 0 });
            });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', _fetchAndApply, { once: true });
    } else {
        _fetchAndApply();
    }
})();
